import type { LessonCourse } from "./schema.ts";
import { explorerPopularitySchema } from "./schema.ts";
import { positionKey } from "../chess/positionKey.ts";

export type ExplorerMoveStat = {
  san: string;
  popularity: "main" | "common" | "sideline" | "rare";
  games?: number;
  share?: number;
};

export type ExplorerSnapshot = {
  source: string;
  importedAt: string;
  attribution: string;
  positions: Record<
    string,
    {
      moves: ExplorerMoveStat[];
    }
  >;
};

export function enrichCourse(course: LessonCourse, snapshot: ExplorerSnapshot): LessonCourse {
  for (const node of Object.values(course.nodes)) {
    const key = positionKey(node.fen);
    const entry = snapshot.positions[key];
    if (!entry) continue;
    for (const move of node.moves) {
      const stat = entry.moves.find((item) => item.san === move.san);
      if (!stat) continue;
      const parsed = explorerPopularitySchema.safeParse(stat.popularity);
      if (parsed.success) move.explorerPopularity = parsed.data;
      if (typeof stat.share === "number") move.frequency = stat.share;
    }
  }
  return course;
}
